import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/arrow-left.svg'
import _imports_1 from '@/assets/images/about/ship.png'
import _imports_2 from '@/assets/images/veles.png'
import _imports_3 from '@/assets/svg/about/10.svg'
import _imports_4 from '@/assets/svg/about/100.svg'
import _imports_5 from '@/assets/svg/about/3.svg'
import _imports_6 from '@/assets/svg/line-big.svg'
import _imports_7 from '@/assets/images/about/adamovich.png'
import _imports_8 from '@/assets/images/about/mosk.png'
import _imports_9 from '@/assets/images/about/sved.png'
import _imports_10 from '@/assets/images/about/nefed.png'
import _imports_11 from '@/assets/images/about/award_1.png'
import _imports_12 from '@/assets/images/about/award_2.png'
import _imports_13 from '@/assets/images/about/award_3.png'
import _imports_14 from '@/assets/images/about/award_4.png'
import _imports_15 from '@/assets/images/about/award_5.png'
import _imports_16 from '@/assets/images/about/award_6.png'
import _imports_17 from '@/assets/images/about/award_7.png'
import _imports_18 from '@/assets/images/about/award_8.png'


const _hoisted_1 = { class: "flex items-center w-full mb-[76px] mt-[40px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex gap-x-16 max-w-[1126px] mx-auto mb-[104px]" }
const _hoisted_5 = { class: "flex flex-col gap-y-[76px]" }
const _hoisted_6 = { class: "flex flex-col gap-y-6 w-[523px]" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "pl-[56px] mb-3" }
const _hoisted_9 = { class: "pl-[112px]" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[645px]"
}, null, -1)
const _hoisted_11 = { class: "flex flex-col justify-center items-center max-w-[1126px] mx-auto" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-[101px] mb-[92px]"
}, null, -1)
const _hoisted_13 = { class: "flex flex-row items-center justify-center gap-x-[26px] px-[124px] border-[3px] border-[var(--primary-color)] h-[114px] w-full rounded-[100px] mb-[92px]" }
const _hoisted_14 = { class: "flex items-center gap-x-[26px]" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-[4.5rem]"
}, null, -1)
const _hoisted_16 = { class: "flex items-center gap-x-[26px]" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_18 = { class: "flex items-center gap-x-[26px]" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_20 = { class: "flex flex-col justify-center items-center max-w-[1126px] mx-auto mb-[92px]" }
const _hoisted_21 = { class: "flex flex-col gap-y-10" }
const _hoisted_22 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "h-[25px] w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_24 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "h-[25px] w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_26 = { class: "max-w-[777px]" }
const _hoisted_27 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "h-[25px] w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1)
const _hoisted_29 = { class: "max-w-[777px]" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "mb-[104px]" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "w-[1366px] mx-auto"
  })
], -1)
const _hoisted_31 = { class: "flex flex-col gap-y-[76px] max-w-[1126px] mx-auto" }
const _hoisted_32 = { class: "p-3" }
const _hoisted_33 = { class: "flex gap-x-[104px] px-[83px] mb-[104px]" }
const _hoisted_34 = { class: "border-[3px] border-[var(--primary-color)] rounded-[50px] w-[428px] py-[20px]" }
const _hoisted_35 = { class: "flex items-center justify-center" }
const _hoisted_36 = { class: "py-[10px] pl-[60px] pr-[40px]" }
const _hoisted_37 = { class: "list-disc" }
const _hoisted_38 = { class: "border-[3px] border-[var(--primary-color)] rounded-[50px] w-[428px] py-[20px]" }
const _hoisted_39 = { class: "flex items-center justify-center" }
const _hoisted_40 = { class: "py-[10px] pl-[60px] pr-[40px]" }
const _hoisted_41 = { class: "list-disc" }
const _hoisted_42 = { class: "flex flex-col max-w-[1366px] mx-auto mb-[104px]" }
const _hoisted_43 = { class: "relative flex flex-row justify-center gap-x-[79px] px-[52px] py-[50px] bg-[var(--primary-color)] w-full mb-[64px]" }
const _hoisted_44 = { class: "flex flex-col gap-y-[32px]" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "w-[236px]"
}, null, -1)
const _hoisted_46 = { class: "flex flex-col gap-y-1" }
const _hoisted_47 = { class: "p-[10px]" }
const _hoisted_48 = { class: "flex flex-col gap-y-[32px]" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "w-[236px]"
}, null, -1)
const _hoisted_50 = { class: "flex flex-col gap-y-1" }
const _hoisted_51 = { class: "p-[10px]" }
const _hoisted_52 = { class: "flex flex-col gap-y-[32px]" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "w-[236px]"
}, null, -1)
const _hoisted_54 = { class: "flex flex-col gap-y-1" }
const _hoisted_55 = { class: "p-[10px]" }
const _hoisted_56 = { class: "flex flex-col gap-y-[32px]" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "w-[236px]"
}, null, -1)
const _hoisted_58 = { class: "flex flex-col gap-y-1" }
const _hoisted_59 = { class: "p-[10px]" }
const _hoisted_60 = { class: "relative flex flex-col max-w-[1126px] mx-auto mb-[104px]" }
const _hoisted_61 = { class: "p-3 mb-[104px]" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-4 justify-items-center items-center gap-x-12 gap-y-9 mb-[64px]\"><img src=\"" + _imports_11 + "\" class=\"w-[207px]\"><img src=\"" + _imports_12 + "\" class=\"w-[207px]\"><img src=\"" + _imports_13 + "\" class=\"w-[207px]\"><img src=\"" + _imports_14 + "\" class=\"w-[207px]\"><img src=\"" + _imports_15 + "\" class=\"w-[207px]\"><img src=\"" + _imports_16 + "\" class=\"w-[207px]\"><img src=\"" + _imports_17 + "\" class=\"w-[207px]\"><img src=\"" + _imports_18 + "\" class=\"w-[207px]\"></div>", 1)

import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "pl-[120px] pr-[76px] cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, _hoisted_3),
      _createVNode(BaseButton, {
        text: _unref(t)('about.title'),
        type: "subtitle",
        ui: "primary",
        color: "var(--black-color)"
      }, null, 8, ["text"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseTypography, {
            text: _unref(t)('about.text.first'),
            type: "body"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('about.text.second'),
            type: "body"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-1.first'),
              type: "title",
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-1.second'),
              type: "title2",
              tag: "span",
              color: "var(--black-color)"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-2.first'),
              type: "title",
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-2.second'),
              type: "title2",
              tag: "span",
              color: "var(--black-color)"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-3.first'),
              type: "title",
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.tagline.text-3.second'),
              type: "title2",
              tag: "span",
              color: "var(--black-color)"
            }, null, 8, ["text"])
          ])
        ])
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.years'),
            type: "body3"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.success'),
            type: "body3"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(BaseTypography, {
            text: _unref(t)('about.labels.direction'),
            type: "body3"
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-1.first'),
              type: "body",
              class: "max-w-[777px]",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-1.second'),
              type: "body2",
              class: "max-w-[777px]",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-1.third'),
              type: "body",
              class: "max-w-[777px]",
              tag: "span"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-2.first'),
              type: "body",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-2.second'),
              type: "body2",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-2.third'),
              type: "body",
              tag: "span"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-3.first'),
              type: "body",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-3.second'),
              type: "body2",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.list.text-3.third'),
              type: "body",
              tag: "span",
              class: "underline"
            }, null, 8, ["text"])
          ])
        ])
      ])
    ]),
    _hoisted_30,
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.guarantee.title'),
          type: "subtitle",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.guarantee.clients.title'),
              type: "special-body",
              color: "var(--primary-color)",
              class: "h-[46px]"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("ul", _hoisted_37, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.first'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.second'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.third'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.clients.fourth'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(BaseTypography, {
              text: _unref(t)('about.guarantee.partners.title'),
              type: "special-body",
              color: "var(--primary-color)",
              class: "h-[46px]"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("ul", _hoisted_41, [
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.first'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.second'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.third'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('about.guarantee.partners.fourth'),
                  type: "special-body4"
                }, null, 8, ["text"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createVNode(BaseTypography, {
        text: _unref(t)('about.team.title'),
        type: "subtitle",
        class: "var(--black-color) mb-[76px]"
      }, null, 8, ["text"]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.first.post'),
                type: "body",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.first.name'),
              type: "body3",
              color: "var(--base-white)",
              class: "pl-[10px]"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.second.post'),
                type: "body",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.second.name'),
              type: "body3",
              color: "var(--base-white)",
              class: "pl-[10px]"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_52, [
          _hoisted_53,
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.third.post'),
                type: "body",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.third.name'),
              type: "body3",
              color: "var(--base-white)",
              class: "pl-[10px]"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _hoisted_57,
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(BaseTypography, {
                text: _unref(t)('about.team.fourth.post'),
                type: "body",
                color: "var(--base-white)",
                class: "max-w-[236px]"
              }, null, 8, ["text"])
            ]),
            _createVNode(BaseTypography, {
              text: _unref(t)('about.team.fourth.name'),
              type: "body3",
              color: "var(--base-white)",
              class: "pl-[10px]"
            }, null, 8, ["text"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createVNode(BaseTypography, {
          text: _unref(t)('about.awards.title'),
          type: "subtitle",
          color: "var(--black-color)"
        }, null, 8, ["text"])
      ]),
      _hoisted_62
    ])
  ], 64))
}
}

})